import { APIHero } from "../../Models/API/APIHero"
import { MainThunkDispatch } from "../../Reducers"
import { apiEndpoints } from "../../Routes/api"
import { apiFetch } from "../Client/NetworkActions"
import { HeroType } from "../Types"

export const getHero = (id: number) => async (dispatch: MainThunkDispatch) => {
    try {
        const endpoint = apiEndpoints.getHero({ id })
        const data = await dispatch(apiFetch<APIHero>(endpoint.url, endpoint))

        if (data === undefined) {
            return
        }

        dispatch({ type: HeroType.set, payload: data })
    } catch (error) {}
}
